import React from 'react';
import styles from './style.module.scss';
import ReviewHeader from '../common/ReviewHeader';
import useSalesFormStore from '../../../../../../../../stores/sales-form';
import CheckIcon from '../../../../../../../../assets/svg/icons/common/CheckIcon';
import CloseIcon from '../../../../../../../../assets/svg/icons/common/CloseIcon';
import { premiseTypeOptions } from '../../../../../../../../../constants';

const BusinessInformation = ({ formik, onEdit, isOpen, onToggle }) => {
  const { values } = formik;
  const mccOptions = useSalesFormStore((state) => state.mccOptions);

  const formatPeriod = (years, months) => {
    const yearText = years > 0 ? `${years} year${years > 1 ? 's' : ''}` : '';
    const monthText = months > 0 ? `${months} mon` : '';
    return [yearText, monthText].filter(Boolean).join(' ');
  };

  const getBusinessTypeName = (id) => {
    if (!id || !mccOptions) return '-';
    const option = mccOptions.find(opt => opt.value === id);
    return option ? option.label : '-';
  };

  const SectionHeader = ({ title }) => (
    <div className={styles.sectionHeader} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span className={styles.sectionTitle}>{title}</span>
      <div className={styles.sectionLine} />
    </div>
  );

  return (
    <div className={styles.business_information}>
      <ReviewHeader
        title="Business Information"
        isOpen={isOpen}
        onToggle={onToggle}
        onEdit={onEdit}
      />

      {isOpen && (
        <div className={styles.content}>
          <div className={styles.detailsGrid}>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>Type of Ownership</div>
              <div className={styles.detailValue}>
                {values.type_of_ownership || '-'}
              </div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>Legal Business Name</div>
              <div className={styles.detailValue}>{values.legal_business_name || '-'}</div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>DBA Name</div>
              <div className={styles.detailValue}>{values.dba_name || '-'}</div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>Tax ID / EIN</div>
              <div className={styles.detailValue}>{values.tax_ein || '-'}</div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>Premise Type</div>
              <div className={styles.detailValue}>
                {premiseTypeOptions.find(opt => opt.value === values.premise_type)?.label || '-'}
              </div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>Period of Ownership</div>
              <div className={styles.detailValue}>
                {formatPeriod(values.ownership_years, values.ownership_months) || '-'}
              </div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>Business Type</div>
              <div className={styles.detailValue}>
                {getBusinessTypeName(values.business_type)}
              </div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.detailLabel}>Tax exempt</div>
              <div className={styles.detailValue}>
                <div className={styles.taxExemptContainer}>
                  {values.tax_exempt === 'yes' ? (
                    <CheckIcon className={styles.checkIcon} />
                  ) : (
                    <CloseIcon className={styles.closeIcon} />
                  )}
                  <span>{values.tax_exempt === 'yes' ? 'Yes' : 'No'}</span>
                </div>
              </div>
            </div>
          </div>

          {/* <div className={styles.section}>
            <SectionHeader title="BUSINESS ADDRESS" />
            <div className={styles.detailsGrid}>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Street Address</div>
                <div className={styles.detailValue}>{values.business_address || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>City</div>
                <div className={styles.detailValue}>{values.business_city || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>State</div>
                <div className={styles.detailValue}>{values.business_state || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Zip</div>
                <div className={styles.detailValue}>{values.business_zip || '-'}</div>
              </div>
            </div>
          </div> */}

          <div className={styles.section}>
            <SectionHeader title="CONTACTS" />
            <div className={styles.detailsGrid}>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Business Phone Number</div>
                <div className={styles.detailValue}>{values.business_phone || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Business Email</div>
                <div className={styles.detailValue}>{values.business_email || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Business Website URL</div>
                <div className={styles.detailValue}>{values.business_website || '-'}</div>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <SectionHeader title="DBA Address" />
            <div className={styles.detailsGrid}>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>DBA Street</div>
                <div className={styles.detailValue}>{values.dba_address || '-'}</div>
              </div>
            </div>
            <div className={styles.detailsGrid}>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>DBA City</div>
                <div className={styles.detailValue}>{values.dba_city || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>DBA State</div>
                <div className={styles.detailValue}>{values.dba_state || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>DBA Zip</div>
                <div className={styles.detailValue}>{values.dba_zip || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Period of Location</div>
                <div className={styles.detailValue}>
                  {formatPeriod(values.location_years, values.location_months) || '-'}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <SectionHeader title="Legal business Address" />
            <div className={styles.detailsGrid}>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Legal Street</div>
                <div className={styles.detailValue}>{values.legal_address || '-'}</div>
              </div>
            </div>
            <div className={styles.detailsGrid}>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Legal City</div>
                <div className={styles.detailValue}>{values.legal_city || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Legal State</div>
                <div className={styles.detailValue}>{values.legal_state || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Legal Zip</div>
                <div className={styles.detailValue}>{values.legal_zip || '-'}</div>
              </div>
              <div className={styles.detailItem}>
                <div className={styles.detailLabel}>Legal Phone Number</div>
                <div className={styles.detailValue}>{values.legal_phone || '-'}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessInformation; 